import { ActionEntityType, ActionIntent, NextActionMode, OfficeActionId, } from '@office-start/action-types';
import { ActionContextMenuItemIcon, ContentActionGroup, } from '@office-start/document-types';
import { OfficeActionCreators } from '../actionCreators/officeActionCreators';
export var getDeleteActions = function (_a) {
    var appId = _a.appId, hubActionStrings = _a.hubActionStrings, systemUserConfig = _a.systemUserConfig;
    var _b = hubActionStrings.documentActionsMenuResources, deleteActionTitle = _b.deleteActionTitle, disabledDeleteActionTooltip = _b.disabledDeleteActionTooltip;
    // Setup next action to be toast type with the Restore action (if available) or just a link to the recycle bin
    var deleteNextAction = {
        nextAction: {
            appId: appId,
            id: OfficeActionId.DeleteRestore,
            mode: NextActionMode.Notification,
        },
        actionDefinition: {
            intent: ActionIntent.ContentEdit,
            entities: [] /* Not visible in any kind of UX */,
            metadata: {
                appId: appId,
                name: hubActionStrings.documentActionsMenuResources
                    .deleteRestoreActionTitle,
                description: hubActionStrings.documentActionsMenuResources
                    .deleteRestoreActionTitle,
                id: OfficeActionId.DeleteRestore,
                notificationOptions: {
                    loading: {
                        showLoadingIndicator: false,
                    },
                    error: {
                        message: hubActionStrings.documentActionsToastResources
                            .deleteRestoreFailed,
                        actionText: hubActionStrings.documentActionsToastResources
                            .deleteUndo,
                    },
                    success: undefined, // No success message needed here. Is handled by next action
                },
            },
            officeActionCreator: function (deletedContent) {
                // If item is a one drive content we can restore it for consumer, otherwise not...
                return OfficeActionCreators.createDeleteRestoreAction({
                    content: deletedContent,
                });
            },
        },
    };
    return [
        // Add restore / view in OneDrive recycle bin
        deleteNextAction.actionDefinition,
        // Delete action...
        {
            intent: ActionIntent.ContentView,
            entities: [{ type: ActionEntityType.Content }],
            metadata: {
                appId: appId,
                badgeText: hubActionStrings.documentActionsMenuResources.newBadgeText,
                groupId: ContentActionGroup.None,
                name: deleteActionTitle,
                description: deleteActionTitle,
                id: OfficeActionId.Delete,
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'DeleteIcon',
                },
            },
            officeActionCreator: function (content) {
                var _a, _b;
                if (!systemUserConfig.userDriveId ||
                    !((_b = (_a = content.actionInfo) === null || _a === void 0 ? void 0 : _a.odspShareInfo) === null || _b === void 0 ? void 0 : _b.enabled) ||
                    content.actionInfo.odspShareInfo.type === undefined) {
                    return undefined;
                }
                if (!content.driveId || !content.docId) {
                    return undefined;
                }
                var isDisabled;
                // driveId in consumer comes back from API as lower case,
                // but is returned in data as uppercase. In commercial, they match...
                if ((content.isOneDriveForBusinessFile &&
                    systemUserConfig.userDriveId.toLowerCase() ===
                        content.driveId.toLowerCase()) ||
                    content.isSharePointFile) {
                    isDisabled = false;
                }
                else {
                    isDisabled = true;
                }
                return OfficeActionCreators.createDeleteAction(content, content.driveId, content.docId, content.sharepointIds, isDisabled ? disabledDeleteActionTooltip : undefined, {
                    content: content,
                    disabled: isDisabled,
                    nextAction: deleteNextAction.nextAction,
                    notificationOptions: {
                        loading: {
                            showLoadingIndicator: false,
                        },
                        success: {
                            // Allow for restore for conusmer items...
                            actionText: systemUserConfig.userType === 'Consumer'
                                ? hubActionStrings
                                    .documentActionsToastResources
                                    .deleteUndo
                                : undefined,
                            // Link to OneDrive - 'View in OneDrive recycle bin.'
                            link: {
                                text: hubActionStrings
                                    .documentActionsMenuResources
                                    .deleteRestoreActionTitle,
                            },
                            // Otherwise, just pass delete success message
                            message: hubActionStrings
                                .documentActionsToastResources
                                .deleteSuccess,
                        },
                    },
                });
            },
        },
    ];
};
//# sourceMappingURL=getDeleteAction.js.map